import { c as _c } from "react/compiler-runtime";
import { IcoSidebarLeftClosed16, IcoSidebarLeftOpen16, ThemedLogoFpFull } from '@onefootprint/icons';
import { ShortcutHint, useShortcut } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { DEFAULT_PUBLIC_ROUTE } from '@/config/constants';
import TooltipWrapper from '../tooltip-wrapper';
type NavHeaderProps = {
  isCollapsed: boolean;
  onSideNavCollapse?: (isCollapsed: boolean) => void;
};
const SHORTCUT_SIDE_NAV_COLLAPSE = ['Meta', 's'];
const NavHeader = t0 => {
  const $ = _c(37);
  const {
    isCollapsed,
    onSideNavCollapse
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav.navHeader"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== isCollapsed || $[2] !== onSideNavCollapse) {
    t2 = () => onSideNavCollapse?.(!isCollapsed);
    $[1] = isCollapsed;
    $[2] = onSideNavCollapse;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleShortcut = t2;
  let t3;
  if ($[4] !== handleShortcut) {
    t3 = {
      keys: SHORTCUT_SIDE_NAV_COLLAPSE,
      onShortcut: handleShortcut
    };
    $[4] = handleShortcut;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useShortcut(t3);
  const t4 = !isCollapsed;
  let t5;
  if ($[6] !== isCollapsed || $[7] !== t4) {
    t5 = cx("flex items-center h-11 shrink-0", {
      "justify-between pl-[21px] pr-3": t4,
      "justify-center": isCollapsed
    });
    $[6] = isCollapsed;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isCollapsed) {
    t6 = !isCollapsed && <Link href={DEFAULT_PUBLIC_ROUTE} aria-label="Footprint" className="flex items-center"><ThemedLogoFpFull className="h-5 w-auto" /></Link>;
    $[9] = isCollapsed;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isCollapsed || $[12] !== t) {
    t7 = isCollapsed ? t(_temp) : t(_temp2);
    $[11] = isCollapsed;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ShortcutHint keys={SHORTCUT_SIDE_NAV_COLLAPSE} />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <>{t7} {t8}</>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = !isCollapsed;
  let t11;
  if ($[17] !== isCollapsed || $[18] !== onSideNavCollapse) {
    t11 = () => onSideNavCollapse?.(!isCollapsed);
    $[17] = isCollapsed;
    $[18] = onSideNavCollapse;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isCollapsed || $[21] !== t) {
    t12 = isCollapsed ? t(_temp3) : t(_temp4);
    $[20] = isCollapsed;
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isCollapsed) {
    t13 = isCollapsed ? <IcoSidebarLeftClosed16 /> : <IcoSidebarLeftOpen16 />;
    $[23] = isCollapsed;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t13) {
    t14 = <button type="button" onClick={t11} className="flex justify-center items-center size-8 md:size-7 rounded-(--icon-button-border-radius) cursor-pointer text-tertiary hover:text-primary hover:bg-hover-control focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20" aria-label={t12}>{t13}</button>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t10 || $[30] !== t14 || $[31] !== t9) {
    t15 = <TooltipWrapper tooltipContent={t9} disableHoverable={t10}>{t14}</TooltipWrapper>;
    $[29] = t10;
    $[30] = t14;
    $[31] = t9;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t5 || $[35] !== t6) {
    t16 = <div className={t5}>{t6}{t15}</div>;
    $[33] = t15;
    $[34] = t5;
    $[35] = t6;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
export default NavHeader;
function _temp($) {
  return $.expand;
}
function _temp2($_0) {
  return $_0.collapse;
}
function _temp3($_1) {
  return $_1.expand;
}
function _temp4($_2) {
  return $_2.collapse;
}